export type TaskSubmitFailureReason = "unauthenticated" | "failed";

export type TaskSubmitResult =
	{ succeeded: true } | { succeeded: false; reason: TaskSubmitFailureReason };

/** A 401 means the bearer token was refused; anything else is worth a retry. */
export const taskSubmitFailureReason = (
	statusCode: number
): TaskSubmitFailureReason =>
	statusCode === 401 ? "unauthenticated" : "failed";

const ACKNOWLEDGE_RETRY_DELAYS_MS = [2_000, 5_000, 10_000];

/** Delay before retrying a failed background acknowledgement; undefined once retries are spent. */
export const nextAcknowledgeDelay = (
	failedAttempt: number
): number | undefined => ACKNOWLEDGE_RETRY_DELAYS_MS[failedAttempt];
